/** Game lock padlock — Agent-API allows hierarchy levels 1–5 (not Member). */
export function canShowGameLock(role: string | null | undefined): boolean {
  return (
    role === 'company-master' ||
    role === 'triple-master' ||
    role === 'double-master' ||
    role === 'super-master' ||
    role === 'master'
  )
}
